import { Box, Paper, Typography, Avatar as MuiAvatar } from '@mui/material';
import { ReactNode } from 'react';

export interface ChatMessageProps {
  message: string;
  timestamp?: string;
  sender?: {
    name: string;
    avatar?: string;
  };
  isCurrentUser?: boolean;
  actions?: ReactNode;
}

export const ChatMessage = ({
  message,
  timestamp,
  sender,
  isCurrentUser = false,
  actions,
}: ChatMessageProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: isCurrentUser ? 'flex-end' : 'flex-start',
        mb: 2,
        gap: 1,
      }}
    >
      {!isCurrentUser && sender && (
        <MuiAvatar
          src={sender.avatar}
          alt={sender.name}
          sx={{ width: 32, height: 32 }}
        >
          {sender.name.charAt(0)}
        </MuiAvatar>
      )}
      <Box sx={{ maxWidth: '70%' }}>
        {!isCurrentUser && sender && (
          <Typography variant="caption" color="text.secondary" sx={{ ml: 1 }}>
            {sender.name}
          </Typography>
        )}
        <Paper
          sx={{
            p: 1.5,
            bgcolor: isCurrentUser ? 'primary.main' : 'grey.100',
            color: isCurrentUser ? 'primary.contrastText' : 'text.primary',
            borderRadius: 2,
          }}
        >
          <Typography variant="body2">{message}</Typography>
        </Paper>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            mt: 0.5,
            ml: 1,
          }}
        >
          {timestamp && (
            <Typography variant="caption" color="text.secondary">
              {timestamp}
            </Typography>
          )}
          {actions}
        </Box>
      </Box>
      {isCurrentUser && sender && (
        <MuiAvatar
          src={sender.avatar}
          alt={sender.name}
          sx={{ width: 32, height: 32 }}
        >
          {sender.name.charAt(0)}
        </MuiAvatar>
      )}
    </Box>
  );
};

export default ChatMessage;
